// ─── CookieConsent.jsx — GDPR cookie consent banner ─────────────────────────
import { useState, useEffect } from "react";
import { useTheme } from "../lib/ThemeContext.jsx";
import { FONT, RADIUS, SPRING } from "../lib/theme.js";

const CONSENT_KEY = "ch_cookie_consent";

export default function CookieConsent() {
  const T = useTheme();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (localStorage.getItem(CONSENT_KEY)) return;
      // Poll until onboarding is done — avoids overlapping the wizard
      const t = setInterval(() => {
        try {
          if (localStorage.getItem(CONSENT_KEY)) { clearInterval(t); return; }
          if (localStorage.getItem("sf_onboarded")) {
            clearInterval(t);
            setVisible(true);
          }
        } catch {}
      }, 2000);
      return () => clearInterval(t);
    } catch {}
  }, []);

  function accept() {
    try { localStorage.setItem(CONSENT_KEY, "accepted"); } catch {}
    setVisible(false);
  }

  function decline() {
    try { localStorage.setItem(CONSENT_KEY, "declined"); } catch {}
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div style={{
      position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 11000,
      background: T.card,
      borderTop: `1px solid ${T.border}`,
      backdropFilter: "blur(20px)", WebkitBackdropFilter: "blur(20px)",
      boxShadow: "0 -8px 32px rgba(0,0,0,0.3)",
      animation: "sfFadeIn 0.35s ease both",
    }}>
      <div style={{
        maxWidth: 960, margin: "0 auto",
        padding: "18px 24px",
        display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap",
        fontFamily: FONT,
      }}>
        <span style={{ fontSize: 22, flexShrink: 0 }}>🍪</span>
        <div style={{ flex: 1, minWidth: 240 }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: T.text, marginBottom: 3 }}>Cookie preferences</div>
          <div style={{ fontSize: 12, color: T.textSub, lineHeight: 1.6 }}>
            We use essential cookies only — to keep you logged in and save your preferences.
            No tracking or advertising cookies. See our{" "}
            <a href="#legal?tab=cookies" style={{ color: T.accent, textDecoration: "underline" }}>Cookie Policy</a>{" "}and{" "}
            <a href="#legal?tab=privacy" style={{ color: T.accent, textDecoration: "underline" }}>Privacy Policy</a>.
          </div>
        </div>
        <div style={{ display: "flex", gap: 10, flexShrink: 0 }}>
          <button onClick={decline} style={{
            background: "transparent", border: `1px solid ${T.border}`,
            borderRadius: RADIUS.md, color: T.textSub, padding: "9px 18px",
            fontSize: 13, fontFamily: FONT, cursor: "pointer",
          }}>Decline</button>
          <button onClick={accept} style={{
            background: T.accent, border: "none",
            borderRadius: RADIUS.md, color: "#fff", padding: "9px 22px",
            fontSize: 13, fontWeight: 700, fontFamily: FONT, cursor: "pointer",
            boxShadow: `0 4px 14px ${T.accent}44`,
          }}>Accept</button>
        </div>
      </div>
    </div>
  );
}
